"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.On = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
/** @deprecated Use the `OnProps` interface from the `@ori/feature-toggles` library */

/** @deprecated Use the `On` component from the `@ori/feature-toggles` library */
const On = ({
  isEnabled,
  children
}) =>
/*#__PURE__*/
// eslint-disable-next-line react/jsx-no-useless-fragment -- false positive
(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
  children: !!isEnabled && children
});
exports.On = On;
